import { render, staticRenderFns } from "./NotificationsTab.vue?vue&type=template&id=6d973af0&scoped=true&"
import script from "./NotificationsTab.vue?vue&type=script&lang=js&"
export * from "./NotificationsTab.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsTab.vue?vue&type=style&index=0&id=6d973af0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d973af0",
  null
  
)

export default component.exports